import api from '@/services/api';

export default {
  namespaced: true,
  state: {
    mostPopular: null,
    analysis: null,
    news: [],
  },
  mutations: {
    updateMostPopular(state, payload) {
      state.mostPopular = payload;
    },
    updateAnalysis(state, payload) {
      state.analysis = payload;
    },
    updateNews(state, payload) {
      state.news = payload;
    },
  },
  actions: {
    getMostPopular({ commit }, payload) {
      return api.insight.getMostPopular(payload.interval, payload.count).then((response) => {
        commit('updateMostPopular', response.data);
        return response.data;
      });
    },
    getAnalysis({ commit }, { limit = 4, offset = 0 }) {
      return api.insight.getAnalysis(limit, offset).then((response) => {
        commit('updateAnalysis', response.data);
        return response.data;
      });
    },
    getFeeds() {
      return api.insight.getFeeds().then((response) => response.data);
    },
    getMarketFeeds({ commit }, marketId) {
      return api.insight.getMarketFeeds(marketId).then((response) => response.data);
    },
    getNews({ commit }, { limit = 4, offset = 0 } = {}) {
      return api.insight.getNews(limit, offset).then((response) => {
        commit('updateNews', response.data);
        return response.data;
      });
    },
  },
};
